/******************************************************************************
 *** MbrasRegulHistory ** 정규직 전환 상세내용
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import React from "react";

import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import MemberFileView from "../../mbras/FileBox/MemberFileView";

interface Props {
    mbrasId        : string;
    mbrasAtrzDocId : string;
    showAtrzLine?  : boolean;
}

const MbrasRegulHistory = ({ mbrasId, mbrasAtrzDocId, showAtrzLine = true }: Props) => {
    const [openLine, setOpenLine] = React.useState(false);

    const [mbrasNm        , setMbrasNm        ] = React.useState(""); // 조합원명
    const [telno          , setTelno          ] = React.useState(""); // 휴대전화번호
    const [brdtDate       , setBrdtDate       ] = React.useState(""); // 생년월일
    const [gndrCd         , setGndrCd         ] = React.useState(""); // 성별코드
    const [mbrasAtrzSeCd  , setMbrasAtrzSeCd  ] = React.useState(""); // 조합원 결재 구분코드
    const [apntYmd        , setApntYmd        ] = React.useState(""); // 발령일자
    const [lbrShpSeCd     , setLbrShpSeCd     ] = React.useState(""); // 현재 근로형태
    const [chgLbrShpSeCd  , setChgLbrShpSeCd  ] = React.useState(""); // 변경 근로형태
    const [ocptTypeCd     , setOcptTypeCd     ] = React.useState(""); // 현재 직종
    const [chgOcptTypeCd  , setChgOcptTypeCd  ] = React.useState(""); // 변경 직종
    const [upOgnzCd       , setUpOgnzCd       ] = React.useState(""); // 현재 본부
    const [chgUpOgnzCd    , setChgUpOgnzCd    ] = React.useState(""); // 변경 본부
    const [ogdpOrgCd      , setOgdpOrgCd      ] = React.useState(""); // 현재 지부
    const [chgOgdpOrgCd   , setChgOgdpOrgCd   ] = React.useState(""); // 변경 지부
    const [wtjrNm         , setWtjrNm         ] = React.useState(""); // 현재 관내
    const [chgWtjrNm      , setChgWtjrNm      ] = React.useState(""); // 변경 관내
    const [addr           , setAddr           ] = React.useState(""); // 현재 주소
    const [chgAddr        , setChgAddr        ] = React.useState(""); // 변경 주소
    const [wthdAtchFileId , setWthdAtchFileId ] = React.useState(""); // 원천징수 첨부파일 ID
    const [wthdFileNm     , setWthdFileNm     ] = React.useState(""); // 원천징수 첨부파일명
    const [etcAtchFileId  , setEtcAtchFileId  ] = React.useState(""); // 기타 첨부파일 ID
    const [etcFileNm      , setEtcFileNm      ] = React.useState(""); // 기타 첨부파일명
    const [listLine       , setListLine       ] = React.useState<any[]>([]); // 결재라인

    // 변경 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc;
                const listItem = res.result.listItem;
                const listFile = res.result.listFile;
                const atrzLine = res.result.listLine;
                const lbrShpItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "01"); // 근로형태
                const ocptTypeItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "02"); // 직종
                const upOgnzItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "03"); // 본부
                const ogdpOrgItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "04"); // 지부
                const wtjrItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "05"); // 관내
                const addrItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "06"); // 주소

                const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02"); // 원천징수 첨부파일
                const etcFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                setMbrasNm(mbrasDoc.mbrasNm);
                setTelno(mbrasDoc.telno);
                setBrdtDate(mbrasDoc.brdtDate);
                setGndrCd(mbrasDoc.gndrCd);
                setMbrasAtrzSeCd(mbrasDoc.mbrasAtrzSeCd);
                setApntYmd(mbrasDoc.applyDt);
                setLbrShpSeCd(lbrShpItem.chgBefCn);
                setChgLbrShpSeCd(lbrShpItem.chgAfterCn);
                setOcptTypeCd(ocptTypeItem.chgBefCn);
                setChgOcptTypeCd(ocptTypeItem.chgAfterCn);
                setUpOgnzCd(upOgnzItem.chgBefCn);
                setChgUpOgnzCd(upOgnzItem.chgAfterCn);
                setOgdpOrgCd(ogdpOrgItem.chgBefCn);
                setChgOgdpOrgCd(ogdpOrgItem.chgAfterCn);
                setWtjrNm(wtjrItem.chgBefCn);
                setChgWtjrNm(wtjrItem.chgAfterCn);
                setAddr(addrItem.chgBefCn);
                setChgAddr(addrItem.chgAfterCn);

                if (Util.isNotEmpty(wthdFileInfo)) {
                    setWthdAtchFileId(wthdFileInfo.mbrasAtchFileId);
                    setWthdFileNm(wthdFileInfo.fileNm);
                }

                if (Util.isNotEmpty(etcFileInfo)) {
                    setEtcAtchFileId(etcFileInfo.mbrasAtchFileId);
                    setEtcFileNm(etcFileInfo.fileNm);
                }

                setListLine(atrzLine);

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId, mbrasId]);

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    return (
        <div className="w100p bsBdb p2 pb8">
            {/* 결재라인 */}
            {showAtrzLine && (
                <AtrzLineBox
                    listLine={listLine}
                    open={openLine}
                    onToggle={() => setOpenLine((value) => !value)}
                    showOrgInfo={true}
                />
            )}

            {/* 조합원 정보 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    조합원 정보
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            성명
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(mbrasNm)}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            휴대전화번호
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.setPhoneNum(telno))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            생년월일
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(brdtDate, "-", "YYYYMMDD"))}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            성별
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("GNDR_CD", gndrCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            문서구분
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("MBRAS_ATRZ_SE_CD", mbrasAtrzSeCd))}
                        </div>
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 bdl1 bdcDDDDDD">
                            발령일자
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(apntYmd, "-", "YYYYMMDD"))}
                        </div>
                    </div>
                </div>
            </div>

            {/* 변경 신청 내역 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    변경 신청 내역
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h40 bgcFAFAFA bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC fm-b fs13 fc555555">
                            구분
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            현재
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            변경
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            근로형태
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("LBR_SHP_SE_CD", lbrShpSeCd))}
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("LBR_SHP_SE_CD", chgLbrShpSeCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            직종
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode(
                                    lbrShpSeCd === "01"
                                        ? "PMEMP_OCPT_TYPE_CD"
                                        : "IREMP_OCPT_TYPE_CD",
                                    ocptTypeCd,
                                ),
                            )}
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode(
                                    chgLbrShpSeCd === "01"
                                        ? "PMEMP_OCPT_TYPE_CD"
                                        : "IREMP_OCPT_TYPE_CD",
                                    chgOcptTypeCd,
                                ),
                            )}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            본부
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getUpOrgName(upOgnzCd))}
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getUpOrgName(chgUpOgnzCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            지부
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getDownOrgName(ogdpOrgCd))}
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getDownOrgName(chgOgdpOrgCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            관내
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(wtjrNm)}
                        </div>
                        <div className="flx1 dpFlx aiC pl18 pr18 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(chgWtjrNm)}
                        </div>
                    </div>

                    <div className="dpFlx minH64">
                        <div className="w140 minH64 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            주소
                        </div>
                        <div className="flx1 minH64 dpFlx aiC pl18 pr18 pt12 pb12 fm-c fs14 fc222222 lh20 bdl1 bdcDDDDDD">
                            {renderValue(addr)}
                        </div>
                        <div className="flx1 minH64 dpFlx aiC pl18 pr18 pt12 pb12 fm-c fs14 fc007bff lh20 bdl1 bdcDDDDDD">
                            {renderValue(chgAddr)}
                        </div>
                    </div>
                </div>
            </div>

            {/* 첨부파일 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    첨부파일
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            원천징수 동의서
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={wthdAtchFileId}
                                mbrFileNm={wthdFileNm}
                            />
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            기타
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                mbrFileNm={etcFileNm}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MbrasRegulHistory;